module.exports = __webpack_public_path__ + "static/img/拖拉机.d8e77d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/360°全景环视系统/拖拉机.png
// module id = GZ0/
// module chunks = 0